import { useTranslate } from "react-admin";
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";
import GrowthIndicator from "../common/GrowthIndicator";
import LineGraph from "../common/LineGraph";

type Props = {
  title: string;
  value: number | string;
  unit?: string;
  stops?: number[];
  isGrowing?: boolean;
  growth?: number;
  isLoading?: boolean;
  isError?: boolean;
  isReverse?: boolean;
};

const ReportCardWidget = ({
  title,
  value,
  unit,
  stops,
  isGrowing = false,
  growth,
  isLoading = false,
  isError = false,
  isReverse = false,
}: Props) => {
  const translate = useTranslate();
  return (
    <Card style={{ position: "relative", height: "100%" }}>
      {isLoading && (
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {isError && (
        <CardContent>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Typography variant="body2" color="error">
              {translate("common.errorLoadingData")}
            </Typography>
          </Box>
        </CardContent>
      )}
      {!isLoading && !isError && (
        <CardContent style={{ padding: "12px 16px" }}>
          <Typography variant="subtitle2" color="textSecondary" style={{ fontSize: "0.75rem", lineHeight: 1.2 }}>
            {title}
          </Typography>
          <Typography variant="h5" style={{ marginTop: 8, fontSize: "1.5rem", lineHeight: 1.2 }}>
            {value ?? 0} {unit}
          </Typography>
          {stops && (
            <Box style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
              <LineGraph
                isGrowing={isGrowing}
                data={stops}
                width={500}
                height={36}
                isReverse={isReverse}
              />
              {growth !== undefined && growth !== null ? (
                <Box style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <GrowthIndicator
                    growth={growth}
                    isGrowing={isGrowing}
                    isReverse={isReverse}
                  />
                </Box>
              ) : null}
            </Box>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default ReportCardWidget;
